import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { DndProvider } from 'react-dnd'
import { TouchBackend } from 'react-dnd-touch-backend'

import Button from '../Button'
import Dropzone from '../Dropzone'

const DocumentUploadModal = ({
  acceptedFiles,
  deleteFunction,
  isOpen,
  onHide,
  uploadFunction,
  maxFileSize = 25,
  maxDropsAtOnce = 10,
  singleUpload = false
}) => {
  const validFunction = typeof uploadFunction === 'function'
  return <Modal show={isOpen}>
    <div className='bg-white'>
      <Modal.Header closeButton={false} bsPrefix='modal-header d-flex align-items-start'>
        <Modal.Title>Upload and Attach Files</Modal.Title>
      </Modal.Header>
      <Modal.Body bsPrefix={'mx-4'}>
        <DndProvider backend={TouchBackend}>
          {/* {children} */}
          <Dropzone
            acceptedFiles={acceptedFiles}
            uploadFunction={uploadFunction}
            deleteFunction={deleteFunction}
            singleUpload={singleUpload}
            maxFileSize={maxFileSize}
            maxDropsAtOnce={maxDropsAtOnce}
            isOpen={isOpen}
          />
        </DndProvider>
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex justify-content-end align-items-center'>
          <Button variant='success' disabled={!validFunction} onClick={() => onHide()}>Done</Button>
        </div>
      </Modal.Footer>
    </div>
  </Modal>
}

DocumentUploadModal.propTypes = {
  acceptedFiles: PropTypes.string,
  deleteFunction: PropTypes.func,
  isOpen: PropTypes.bool,
  onHide: PropTypes.func,
  uploadFunction: PropTypes.func,
  maxFileSize: PropTypes.number,
  maxDropsAtOnce: PropTypes.number,
  size: PropTypes.string,
  singleUpload: PropTypes.bool
}

export default DocumentUploadModal
